// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React, { useState } from 'react';
import logo_circle from '../assets/logos/logo_uc_blues_on_white.svg';
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../context/FirebaseConfig';

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [requestSent, setRequestSent] = useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setMessage(""); // Reset message

         // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        if (!email) {
            setMessage("If this email exists, you will receive a reset link.");
            return;
        }

        // Check the email format is valid using regex
        if (!emailRegex.test(email)) {
            setMessage("Please enter a valid email.");
            return;
        }

        if (requestSent) {
            setMessage("Password reset already requested.");
            return;
        }
    
        setRequestSent(true);
        
        try {
            await sendPasswordResetEmail(auth, email);
        } catch (err) {
            // Suppress Firebase error logging
            if (err.code !== "auth/user-not-found") {
                console.error("Firebase Error:", err); // Log only unexpected errors
            }
        } finally {
            // Always show the same message
            setMessage("If this email exists, you will receive a reset link.");
        }
    };
    

    return (
        <div className="formContainer">
            <div className="formWrapper">
                <img className="logo" src={logo_circle} alt="UpCircle Logo" />
                <span className='logo_caption'>
                    <span className='brand'>UpCircle</span> Analytics
                </span>
                <span className='title'>Reset Password</span>

                <form onSubmit={handleResetPassword}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={requestSent}>Send Reset Link</button>
                    
                </form>

                {message && <span className='reset-success'>{message}</span>}

                <p className='reset-message'>Or click here to <a href="/login">Login</a></p>
            </div>
            <div className='upcircleFooter'>
                <span className='brand'>UpCircle Technology AG</span>
                <span className='year'>{new Date().getFullYear()}</span>
            </div>
        </div>
    );
};

export default ResetPassword;

